// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"9358739d364dae5d8443","678":"a34af71b771b4babbc76"}[chunkId] + ".js";
};